// Angular
import { Component, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { BroadcastService, ModalService, ModalSize } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ShowProductModalComponent } from '../modals/show-product-modal.component';

@Component({
	selector: 'cv-show-product-modal-custom-action',
	templateUrl: './custom-action-show-product-modal-cell.component.html',
	styleUrls: ['./custom-action-show-product-modal-cell.component.scss']
})
export class CustomActionShowProductModalCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy = new Subject();
	public cellValue: any;
	public index: any;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcastService: BroadcastService,
		private modalService: ModalService,
	) { }

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.index = params.rowIndex;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		this.index = params.rowIndex;
		return true;
	}

	/**
	 * Show product Modal
	 */
	onShowProductModal(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: ShowProductModalComponent,
				data: {
					productId: this.cellValue.productId,
				},
				modalConfiguration: {
					title: `Product: ${this.cellValue.productName}`,
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
